
const {
  PRODUCTS
} = require("../types");

const urlBase = "https://api-sonho-com-br.umbler.net";
//const urlBase = "http://app2.sonsap.com.br:7000";
//const urlBase = "http://localhost:7000";

const informationValues = [
  {
    label: 'Home',
    values: []
  },
  {
    label: 'Bolsas',
    values: [{
      label: 'Bolsa Couro G',
      value: 0,
      total: 0,
      action: true
    }, {
      label: 'Bolsa Couro M',
      value: 0,
      total: 438.9,
      action: true
    }, {
      label: 'Bolsa Couro P',
      value: 0,
      total: 793.9,
      action: false
    }, {
      label: 'Bolsa Sint G',
      value: 0,
      total: 0,
      action: true
    }, {
      label: 'Bolsa Sint G',
      value: 0,
      total: 0,
      action: true
    }]
  }, {
    label: 'Sapatos'
  }, {
    label: 'Acessórios',
    values: [{
      label: 'Carteira',
      value: 0,
      total: 5098,
      action: true
    }, {
      label: 'Chaveriro',
      value: 0,
      total: 3678,
      action: true
    }, {
      label: 'Cinto',
      value: 0,
      total: 4318,
      action: true
    }, {
      label: 'Porta Cartao',
      value: 0,
      total: 1749,
      action: true
    }, {
      label: 'Porta Niquel',
      value: 0,
      total: 0,
      action: true
    }]

  }
]

const carregaProdutos = function () {
  return fetch(urlBase + '/api-sr/listaprodutos/')
    .then(response => response.json());
  //.then(data => console.log(data))   
};

const carregaCores = function (mat_referencia) {
  return fetch(urlBase + '/api-sr/listacores/' + mat_referencia)
    .then(response => response.json());
  //.then(data => console.log(data))   
};

const carregaPacks = function (mat_referencia,mat_cor) {
  return fetch(urlBase + '/api-sr/gradeporreferenciaecor/' + mat_referencia + '&' + mat_cor)
    .then(response => response.json());
  //.then(data => console.log(data))   
};

const carregaSize = function (mat_referencia,gap_codigo,mat_cor) {
  return fetch(urlBase + '/api-sr/tamanhoepack/'+ mat_referencia + '&' + gap_codigo + '&' + mat_cor)
    .then(response => response.json());
  //.then(data => console.log(data))   
};

const carregaPayments = function (ref_referencia,ped_condicao) {
  return fetch(urlBase + '/api-sr/formasdepagamento/' + ref_referencia + '&' + ped_condicao)
    .then(response => response.json());
  //.then(data => console.log(data))   
};

const carregaDeliver = function (mat_referencia,ped_condicao) {
  return fetch(urlBase + '/api-sr/datadeentrega/' + mat_referencia + '&' + ped_condicao)
    .then(response => response.json());
  //.then(data => console.log(data))   
};

const carregaOrder = function () {
  return fetch(urlBase + '/api-sr/itempedido2/')
    .then(response => response.json());
  //.then(data => console.log(data))   
};

const carregaProdMatRef = function (mat_referencia) {
  return fetch(urlBase + '/api-sr/produtopormatreferencia/' + mat_referencia )
    .then(response => response.json());
  //.then(data => console.log(data))   
};

export const getShopingCards = () => dispatch => {
  carregaProdutos().then(data => {
    const cards = data.map(element => {
      const obj = {
        url: '../../../images/no-image-icon.png',
        title: element.REF_DESCRICAO,
        value: element.PRECO_PRODUTO,
        total: element.PRECO_VENDA,
        ref: element.REF_REFERENCIA,
        model: element.REF_MODELO,
        cor: element.COR_CODIGO

      };
      const urlImg = '../../../upload-fotos/' + element.REF_REFERENCIA.substr(0, 5).concat(element.COR_CODIGO) + ' (1).jpg';
      if (urlImg === undefined) {
        obj.url = urlImg;
      }
      return obj;

    })

    dispatch({
      type: PRODUCTS.PRODUCT_CARTS,
      payload: cards
    })
  }) 
}

export const getProductsInformation = () => dispatch => {
  dispatch({
    type: PRODUCTS.PRODUCT_INFORMATION,
    payload: informationValues
  })
}

export const getProductsOrders = () => dispatch => {
  
  const productsOrders = [];
  carregaOrder().then(data => {
  data.forEach(element => {
    //console.log(element)
    productsOrders.push (element);
      });            
      
    }).then(() => {
      dispatch({
        type: PRODUCTS.PRODUCT_INFORMATION,
        payload: productsOrders        
      })
    });
}

const carregaItemProduto = function (id) {
  const ref_referencia = id;
  return fetch(urlBase + '/api-sr/listaprodutos2/' + ref_referencia)
    .then(response => response.json())
  //.then(data => console.log(data))   
}

const carregaProdutosRel = function (ref_modelo) {
  return fetch(urlBase + '/api-sr/produtosrelacionados/' + ref_modelo)
    .then(response => response.json())
  //.then(data => console.log(data))   
}

export const getProductItem = id => dispatch => {
  const productItemColor = [];
  const productItemSize = [];
  const productItemPacks = [];
  const productItemRel = [];
  const productItemPay = [];
  const productItemDeliver = [];
  const productItemOrder = [];
  const productProdMatRef = [];

  carregaItemProduto(id).then(data => {
    const productItem = data.map(element => {
      let obj = {
        id: element.REF_REFERENCIA,
        mat_referencia: element.MAT_REFERENCIA,
        url: '../../../images/no-image-icon.png',
        modelo: element.REF_MODELO,
        gap: element.GAP_CODIGO,
        tamanho: element.TAM_TAMANHO,
        mat_tamanho: element.TAM_TAMANHO,
        mat_codigo: element.MAT_CODIGO,
        cor_codigo: element.COR_CODIGO,
        cor_descricao: element.COR_DESCRICAO,
        mat_cor: element.MAT_COR,
        gap_grade: element.GAP_GRADE,
        gap_codigo: element.GPI_CODIGO,
        gap_quantidade: element.GPI_QUANTIDADE,
        ref_descricao: element.REF_DESCRICAO,
        preco_venda: element.PRE_PRECO2,
        preco_produto: element.PRE_PRECO1,
        fornecedor: element.REF_FORNECEDOR
      }
      let urlImg = '../../../upload-fotos/' + element.REF_REFERENCIA.substr(0, 5).concat(element.COR_CODIGO) + ' (1).jpg'
      if (urlImg === undefined) {
        obj.url = urlImg;
      }
      return obj;
    });

    data.map(element => {
      carregaCores(element.REF_REFERENCIA).then(dataCor => {
       dataCor.forEach(element => {
        productItemColor.push(element.COR_DESCRICAO);
        });
    }).then(() => {
        dispatch({
          type: PRODUCTS.PRODUCT_ITEM,
          payload: {
            productItem: productItem,
            productItemColor: productItemColor,
            productItemPacks: productItemPacks,
            productItemSize: productItemSize,
            productItemPay: productItemPay,
            productItemDeliver: productItemDeliver,
            productItemRel: productItemRel,
            productItemOrder: productItemOrder,
            productProdMatRef: productProdMatRef
          }
        });
      });
      return element;
    });

    data.map(element => {
      carregaPacks(element.MAT_REFERENCIA,element.MAT_COR).then(dataPack => {
        dataPack.forEach(element => {
          productItemPacks.push(element.GAP_DESCRICAO.substr(0, 3));
          });  
        
      }).then(() => {
        dispatch({
          type: PRODUCTS.PRODUCT_ITEM,
          payload: {
            productItem: productItem,
            productItemColor: productItemColor,
            productItemPacks: productItemPacks,
            productItemSize: productItemSize,
            productItemPay: productItemPay,
            productItemDeliver: productItemDeliver,
            productItemRel: productItemRel,
            productItemOrder: productItemOrder,
            productProdMatRef: productProdMatRef
          }
        });
      });
      return element;
    });

    

    data.map(element => {
      carregaProdMatRef(element.MAT_REFERENCIA).then(dataProdMatRef => {
        if (dataProdMatRef.length > 0) {
          return productProdMatRef.push(dataProdMatRef.map(element => {
            return element.MAT_REFERENCIA + element.COR_CODIGO + element.MAT_COR;
          }));
        }
      }).then(() => {
        dispatch({
          type: PRODUCTS.PRODUCT_ITEM,
          payload: {
            productItem: productItem,
            productItemColor: productItemColor,
            productItemPacks: productItemPacks,
            productItemSize: productItemSize,
            productItemPay: productItemPay,
            productItemDeliver: productItemDeliver,
            productItemRel: productItemRel,
            productItemOrder: productItemOrder,
            productProdMatRef: productProdMatRef
          }
        });
      });
      return element;
    });

    data.map(element => {
      carregaProdutosRel(element.REF_MODELO).then(responseRel => {
        responseRel.forEach(element => {
          productItemRel.push({
            url: "../../images/no-image-icon.png",
            title: element.REF_DESCRICAO,
            value: element.PRECO_PRODUTO,
            total: element.PRECO_VENDA,
            ref: element.REF_REFERENCIA
          });
        });  
      }).then(() => {
        dispatch({
          type: PRODUCTS.PRODUCT_ITEM,
          payload: {
            productItem: productItem,
            productItemColor: productItemColor,
            productItemPacks: productItemPacks,
            productItemSize: productItemSize,
            productItemPay: productItemPay,
            productItemDeliver: productItemDeliver,
            productItemRel: productItemRel,
            productItemOrder: productItemOrder,
            productProdMatRef: productProdMatRef
          }
        });
      });
      return element;
    });

    data.map(element => {
    carregaSize(element.MAT_REFERENCIA,element.GAP_CODIGO,element.MAT_COR).then(responseSize => {
      responseSize.forEach(elementSize => {
          productItemSize.push({
            tamanho: elementSize.TAM_TAMANHO,
            size: elementSize.GPI_QUANTIDADE
          });
          
        //return elementSize.TAM_TAMANHO AND elementSize.GPI_QUANTIDADE;
      });
    }).then(() => {
      dispatch({
        type: PRODUCTS.PRODUCT_ITEM,
        payload: {
          productItem: productItem,
          productItemColor: productItemColor,
          productItemPacks: productItemPacks,
          productItemSize: productItemSize,
          productItemPay: productItemPay,
          productItemDeliver: productItemDeliver,
          productItemRel: productItemRel,
          productItemOrder: productItemOrder,
          productProdMatRef: productProdMatRef
        }
      });
    });
    return element;
  });

    data.map(element => {
    carregaPayments(element.REF_REFERENCIA,element.PED_CONDICAO).then(responsePay => {
      responsePay.forEach(elementPay => {
        //console.log(responsePay)
        productItemPay.push({
          ped: elementPay.PED_CONDICAO,
          descricao: elementPay.CON_DESCRICAO
          
        }); 
      });
    }).then(() => {
      dispatch({
        type: PRODUCTS.PRODUCT_ITEM,
        payload: {
          productItem: productItem,
          productItemColor: productItemColor,
          productItemPacks: productItemPacks,
          productItemSize: productItemSize,
          productItemPay: productItemPay,
          productItemDeliver: productItemDeliver,
          productItemRel: productItemRel,
          productItemOrder: productItemOrder,
          productProdMatRef: productProdMatRef
        }
      });
    });
    return element;
  });

  data.map(element => {
    carregaDeliver(element.MAT_REFERENCIA,element.PED_CONDICAO).then(responseDeliver => {
      //console.log(responseDeliver)
      responseDeliver.forEach(elementDeliver => {
        productItemDeliver.push({
          data: elementDeliver.ENTREGA
        }); 
      });
      
  }).then(() => {
      dispatch({
        type: PRODUCTS.PRODUCT_ITEM,
        payload: {
          productItem: productItem,
          productItemColor: productItemColor,
          productItemPacks: productItemPacks,
          productItemSize: productItemSize,
          productItemPay: productItemPay,
          productItemDeliver: productItemDeliver,
          productItemRel: productItemRel,
          productItemOrder: productItemOrder,
          productProdMatRef: productProdMatRef
        }
      });
    });
    return element;
  }); 

    
    dispatch({
      type: PRODUCTS.PRODUCT_ITEM,
      payload: {
        productItem: productItem,
        productItemColor: productItemColor,
        productItemPacks: productItemPacks,
        productItemSize: productItemSize,
        productItemPay: productItemPay,
        productItemDeliver: productItemDeliver,
        productItemRel: productItemRel,
        productItemOrder: productItemOrder,
        productProdMatRef: productProdMatRef
      }
    });
  })
}